import { Controller, FieldValues } from "react-hook-form";
import { FormControllerProp } from "../form-controller-prop.interface";
import { KeyboardEventHandler } from "react";
import { InputTextarea } from "primereact/inputtextarea";
import classNames from "classnames";
import FormError from "../form-error/form-error";

export interface InputTextareaControlProps<FieldsType extends FieldValues>
  extends FormControllerProp<FieldsType> {
  rows?: number;
  cols?: number;
  label?: string;
  placeholder?: string;
  className?: string;
  containerClassName?: string;
  disabled?: boolean;
  hint?: string;
  onKeyDown?: KeyboardEventHandler<HTMLTextAreaElement> | undefined;
}

export function InputTextareaControl<FieldsType extends FieldValues>({
  rows = 5,
  cols = 30,
  rules,
  label,
  control,
  name,
  placeholder,
  className,
  containerClassName,
  disabled,
  hint,
  onKeyDown,
}: InputTextareaControlProps<FieldsType>) {
  return (
    <Controller
      name={name}
      control={control}
      rules={rules}
      render={({ field, fieldState }) => (
        <div className={classNames("field mt-5", containerClassName)}>
          <span className="p-float-label">
            <InputTextarea
              id={field.name}
              value={field.value}
              rows={rows}
              cols={cols}
              disabled={disabled}
              placeholder={placeholder}
              className={classNames(
                { "p-invalid": fieldState.error },
                className
              )}
              onChange={(e) => field.onChange(e.target.value)}
              onKeyDown={onKeyDown}
            />

            <label className="text-xs text-gray-500" htmlFor={field.name}>
              {label}
            </label>
          </span>
          {hint && <small className="text-gray-400 mb-1">{hint}</small>}
          {fieldState.error && (
            <FormError error={fieldState.error} className="mt-1" />
          )}
        </div>
      )}
    />
  );
}

export default InputTextareaControl;
